import { GET_RATINGS, GET_RATING_DETAILS } from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const ratingSlice = createCrudSlice({
  name: "ratings",
  urls: {
    getList: GET_RATINGS,
    getDetails: GET_RATING_DETAILS,
  },
  initialFilters: {
    rating: [],
    sentiment: "",
    issueTags: [],
    userId: "",
    branchId: "",
    hasComment: "",
  },
});

// Export actions
export const { setFilter, resetFilters } = ratingSlice.actions;

// Export thunks
export const { getList: getRatingsList, getDetails: getRatingDetails } =
  ratingSlice.thunks;

// Export reducer
export default ratingSlice.reducer;
